import PropTypes from 'prop-types'
import styled from 'astroturf/react'
import { useEffect } from 'react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
const colorBgWhiteL1 = 'var(--color-bg-white-l-1, rgba(255, 255, 255, 1))'
const textColorLevel3 = 'var(--text-color-level3, rgba(26, 26, 26, 0.1))'

import { resetTheme } from 'initializers/theme'
import { useFeatures } from 'components/use_organization'
import Branding from 'components/branding'
import _StyledContainer from "layout-StyledContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/layout.js?styleId=StyledContainer";


const StyledContainer = /*#__PURE__*/styled('div', null, {
  displayName: "StyledContainer",
  styles: _StyledContainer,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletUp: useDeviceType('isTabletUp'),
    isTabletDown: useDeviceType('isTabletDown'),
    isDesktopUp: useDeviceType('isDesktopUp')
  })
})

export const Layout = ({
  children,
  expanded = false,
  hiddenSidebar = false,
  ...props
}) => {
  const { data } = useFeatures()

  useEffect(() => {
    if (data) {
      const { custom_theme_allowed: customThemeAllowed } = data
      if (!customThemeAllowed) {
        resetTheme()
      }
    }
  }, [data])

  return (
    <StyledContainer
      data-id="personalized-confirmation-container"
      {...props}
      expanded={expanded}
      hiddenSidebar={hiddenSidebar}
      data-container="booking-container"
    >
      <Branding />
      {children}
    </StyledContainer>
  )
}

Layout.propTypes = {
  expanded: PropTypes.bool,
  hiddenSidebar: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}
